import { render, staticRenderFns } from "./noticDialogChrome.vue?vue&type=template&id=273cf01a&scoped=true&"
import script from "./noticDialogChrome.vue?vue&type=script&lang=js&"
export * from "./noticDialogChrome.vue?vue&type=script&lang=js&"
import style0 from "./noticDialogChrome.vue?vue&type=style&index=0&id=273cf01a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273cf01a",
  null
  
)

export default component.exports